import { render, staticRenderFns } from "./titulos.vue?vue&type=template&id=2faf7ead&scoped=true&"
import script from "./titulos.vue?vue&type=script&lang=js&"
export * from "./titulos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faf7ead",
  null
  
)

export default component.exports